/**
 * Hides a Rebuy cart cross-sell widget ("Recommended add-on" cards inside the
 * cart drawer, data-rebuy-component="cross-sell-widget") once its own add
 * button has been used. Once the recommended item is in the cart, the widget
 * has nothing left to recommend, so it shouldn't keep taking up space.
 *
 * The widget's add button is rendered/handled entirely by Rebuy's own script,
 * so we don't have a direct hook into its request. Instead we record which
 * widget a click originated from (capture phase, so we run before Rebuy's own
 * click handling), then hide that widget on the next Rebuy cart-change event
 * — the same event set assets/a-rebuy-gift-sync.js already relies on.
 */
(function () {
  if (window.__vrCrossSellHideBound) return;
  window.__vrCrossSellHideBound = true;

  var WIDGET_SELECTOR = '[data-rebuy-component="cross-sell-widget"]';
  var PENDING_TIMEOUT_MS = 8000;

  var pendingWidget = null;
  var pendingTimer = null;

  function clearPending() {
    pendingWidget = null;
    clearTimeout(pendingTimer);
    pendingTimer = null;
  }

  function hideWidget(widget) {
    widget.style.display = 'none';
    widget.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener(
    'click',
    function (event) {
      var widget = event.target.closest && event.target.closest(WIDGET_SELECTOR);
      if (!widget) return;
      var button = event.target.closest('button, [type="submit"], a');
      if (!button) return;

      pendingWidget = widget;
      clearTimeout(pendingTimer);
      pendingTimer = setTimeout(clearPending, PENDING_TIMEOUT_MS);
    },
    true
  );

  function onCartChanged() {
    if (!pendingWidget) return;
    var widget = pendingWidget;
    clearPending();
    hideWidget(widget);
  }

  [
    'rebuy:cart.change', 'rebuy:cart.refresh', 'rebuy:cart.ready',
    'cart:refresh', 'cart:updated', 'cart-updated', 'l:cart:updated',
  ].forEach(function (evt) {
    document.addEventListener(evt, onCartChanged);
    document.documentElement.addEventListener(evt, onCartChanged);
  });
})();
